/**
 * 官网（official_website_new）的视图工具，PC / Mobile 两套 App 共用。
 *
 * 视图切换沿用价格页的做法：同一份 HTML 里切 state，不新增 webpack 入口。
 * `?view=` 选择子页，资讯详情额外通过 `newsId` 标识文章；分享 / 刷新可恢复当前页。
 * 白名单之外的取值一律回 landing，脏参数不会把页面渲染成空白。
 */

/** 独立子页（顶栏 Tab / 移动端抽屉）的视图 key；landing 是首页本身，不列进来 */
export const SUB_VIEWS = ["price", "news"];

/**
 * 从查询串里读初始视图。
 * @param {string} [search] 默认取 `window.location.search`（`useState(getInitialView)` 会走默认值）
 * @returns {"landing"|"price"|"news"}
 */
export function getInitialView(search) {
  const query = search === undefined ? window.location.search : search;
  const view = new URLSearchParams(query).get("view");
  return SUB_VIEWS.indexOf(view) >= 0 ? view : "landing";
}
